import { PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetAddedAssignedUserLeads } from 'cpool-tables/backend-resolvers';
import { getActiveOrFirstUserId } from 'cpool-utils';
import { useTranslation } from 'react-i18next';

import { NotificationItemRow } from './NotificationItemRow';
import { useUserDisplayName } from '~/components/Dialogs/hooks/useUserDisplayName';
import { useMarkNotificationProcessed } from '~/features/notifications/hooks/useMarkNotificationProcessed';
import { getApplicantPreviewName } from '~/features/notifications/utils/getApplicantPreviewName';
import { getNotificationLinkOptions } from '~/features/notifications/utils/getNotificationLinkOptions';

type Props = {
    lead: SchemaLoanRequestResolver_GetAddedAssignedUserLeads[number];
    onNavigate: () => void;
};

export const AddedAdvisorNotificationRow: React.FC<Props> = ({ lead, onNavigate }) => {
    const { t } = useTranslation();
    const { addedAssignedUser } = lead;
    // handed on by the previous advisor, else added on the owner's side
    const handedOnBy = addedAssignedUser?.previousUserId;
    const name = useUserDisplayName(handedOnBy ?? getActiveOrFirstUserId(lead) ?? undefined);
    const { mutate: markProcessed } = useMarkNotificationProcessed();
    if (!addedAssignedUser) return null;

    return (
        <NotificationItemRow
            previewName={getApplicantPreviewName(lead.antragsteller1?.personendaten)}
            previewDetail={
                name
                    ? t(
                          handedOnBy
                              ? 'TOP_HEADER.NOTIFICATIONS.ADDED_BY_HAND_ON'
                              : 'TOP_HEADER.NOTIFICATIONS.ADDED_BY',
                          {
                              name,
                          },
                      )
                    : ''
            }
            timestamp={addedAssignedUser.addedAt}
            link={getNotificationLinkOptions(PROCESSED_NOTIFICATION_KINDS.ASSIGNED_USER_ADDED, lead.id)}
            onNavigate={() => {
                markProcessed({
                    addedAt: addedAssignedUser.addedAt,
                    kind: PROCESSED_NOTIFICATION_KINDS.ASSIGNED_USER_ADDED,
                    loanRequestId: lead.id,
                });
                onNavigate();
            }}
        />
    );
};
